<template>
    <fieldset>
        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Host(ftp://..)</div>
            </div>
            <input
                type="host"
                class="form-control"
                required
                pattern="ftp://.+"
                v-model="host"
                @input="onUpdate"
            />
            <small class="py-2">
                Du kan ange port enligt nedan ftp://&lt;host&gt;:&lt;port&gt;
                t.ex. ftp://myftphost.com:2977. Som standard är det port 21.
            </small>
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Username</div>
            </div>
            <input
                type="text"
                class="form-control"
                v-model="username"
                @input="onUpdate"
                placeholder="anonymous"
            />
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <div class="input-group-text">Password</div>
            </div>
            <input
                type="password"
                class="form-control"
                v-model="password"
                @input="onUpdate"
            />
        </div>
    </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const host = ref(null);
const username = ref(null);
const password = ref(null);
const serializedValue = computed(() => {
  return {
    host: host.value,
    username: username.value,
    password: password.value
  };
});
function onUpdate() {
    emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    host.value = modelValue.value.host;
    username.value = modelValue.value.username;
    password.value = modelValue.value.password;
    if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
      onUpdate();
    }
  }
}, {
  immediate: true
});
</script>
